import React from 'react';

import AXplugin from './AXplugin';

export function pluginActionButtons() {
  return [<AXplugin key={'AXplugin'} />];
}
